// Logos
export { default as LogosSponsors } from "./LogosSponsors";
export type { default as LogosSponsorsProps } from "./LogosSponsorsProps.interface";